<template>
  <v-dialog v-model="journeyDialog" max-width="670px" scrollable>
    <v-card color="background">
      <v-card-title
        class="pr-2"
        :style="{ backgroundColor: companyPrimaryColor }"
      >
        <h2 style="color:white">Resultaten bewerken</h2>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closeEditSurveyDialog()">
          <v-icon dark color="white">close</v-icon>
        </v-btn>
      </v-card-title>

      <div
        v-if="surveyData && ratingSumData.length > 0"
        class="score-wrapper py-2"
        :style="{ backgroundColor: $vuetify.theme.themes[theme].menu }"
      >
        <p class="ma-0 pa-0 text-center" v-if="survey.clientLanguage == 'nl'">
          <b>Gemiddelde score</b>
        </p>
        <p class="ma-0 pa-0 text-center" v-else><b>Average score</b></p>
        <p class="ma-0 pa-0 text-center average-score">{{ averageScore }}</p>
      </div>

      <v-alert class="ma-2 pa-2" v-if="feedback" :value="true" type="warning">
        {{ feedback }}
      </v-alert>

      <v-divider></v-divider>

      <v-card-text>
        <div v-if="journeyLoading">
          <div class="loading-dots">
            <div class="loading-dots-loader"></div>
          </div>
        </div>

        <div v-else>
          <div
            class="survey-items-wrapper"
            v-for="question in surveyData"
            :key="question.order"
            :style="{ backgroundColor: $vuetify.theme.themes[theme].menu }"
          >
            <div
              class="survey-item"
              :class="{ selected: question.rating }"
              v-if="question.type == 'rating'"
            >
              <h2 class="text-center">
                {{ question.question[survey.clientLanguage] }}
              </h2>
              <div class="icon-wrapper clear">
                <v-radio-group
                  v-model="question.rating"
                  :mandatory="false"
                  @click.native="ratingSum()"
                >
                  <a
                    class="rating-icon rating-slecht"
                    :class="'rating-' + question.rating"
                    ><v-radio label="slecht" value="1"></v-radio
                  ></a>
                  <a
                    class="rating-icon rating-onvoldoende"
                    :class="'rating-' + question.rating"
                    ><v-radio label="onvoldoende" value="2"></v-radio
                  ></a>
                  <a
                    class="rating-icon rating-voldoende"
                    :class="'rating-' + question.rating"
                    ><v-radio label="voldoende" value="3"></v-radio
                  ></a>
                  <a
                    class="rating-icon rating-goed"
                    :class="'rating-' + question.rating"
                    ><v-radio label="goed" value="4"></v-radio
                  ></a>
                  <a
                    class="rating-icon rating-super"
                    :class="'rating-' + question.rating"
                    ><v-radio label="super" value="5"></v-radio
                  ></a>
                </v-radio-group>
              </div>

              <div class="feedback-option">
                <div class="feedback-option-label">
                  <span v-if="question.rating < 4">
                    <span v-if="survey.clientLanguage == 'nl'"
                      >Wat hadden wij beter kunnen doen?</span
                    >
                    <span v-else>What could we have done better?</span>
                  </span>
                  <span v-if="question.rating == 4">
                    <span v-if="survey.clientLanguage == 'nl'"
                      >Wat kunnen we nog verbeteren?</span
                    >
                    <span v-else>What can we improve?</span>
                  </span>
                  <span v-if="question.rating == 5">
                    <span v-if="survey.clientLanguage == 'nl'"
                      >Wat vond je zo geweldig?</span
                    >
                    <span v-else>What did you love so much?</span>
                  </span>
                </div>

                <textarea
                  placeholder="Schrijf hier je feedback..."
                  v-model="question.feedback"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions
        :style="{ backgroundColor: $vuetify.theme.themes[theme].menu }"
      >
        <v-container grid-list-md fluid class="ma-0 pa-0">
          <v-layout row wrap class="ma-0 pa-0">
            <v-flex
              xs12
              md6
              class="text-left"
              v-if="
                $vuetify.breakpoint.name != 'sm' &&
                  $vuetify.breakpoint.name != 'xs'
              "
            >
              <v-btn
                outlined
                depressed
                color="#8B93A6"
                @click="closeEditSurveyDialog()"
              >
                Annuleren
              </v-btn>
            </v-flex>
            <v-flex xs12 md6 class="text-right">
              <v-btn
                :disabled="!changed || busy"
                :depressed="!changed || busy"
                :dark="changed || busy"
                :block="
                  $vuetify.breakpoint.name == 'sm' ||
                    $vuetify.breakpoint.name == 'xs'
                "
                rounded
                :color="companySecondaryColor"
                @click="updateQuestions()"
              >
                Beoordeling opslaan
                <v-icon right dark>chevron_right</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import db from "../../firebase/init";
import firebase from "firebase/compat/app";
import platform from "platform";
import { bus } from "../../main";
import _ from "lodash";

export default {
  name: "edit-survey-data",
  props: {
    activeCompData: Object,
    type: String,
  },

  data() {
    return {
      journeyDialog: false,
      journeyLoading: true,
      busy: false,
      feedback: null,
      survey: null,
      surveyData: null,
      surveyDataOriginal: null,
      ratingSumData: [],
    };
  },

  created() {
    bus.$on("getJourneyData", (journeyId) => {
      this.loadJourneyData(journeyId);
      this.journeyDialog = true;
    });
  },

  methods: {
    closeEditSurveyDialog() {
      this.journeyDialog = false;
      this.journeyLoading = true;
    },

    ratingSum() {
      this.ratingSumData = [];
      this.surveyData.forEach((element) => {
        if (element.rating) {
          this.ratingSumData.push(Number(element.rating));
        }
      });
    },

    loadJourneyData(journeyId) {
      this.journeyLoading = true;
      db.collection("surveys")
        .doc(journeyId)
        .get()
        .then((doc) => {
          this.survey = doc.data();
          this.survey.id = doc.id;
          this.surveyData = _.orderBy(
            this.survey.surveyQuestions,
            "order",
            "asc",
          );
          this.surveyDataOriginal = _.cloneDeep(this.surveyData);
        })
        .then(() => {
          this.ratingSum();
        })
        .then(() => {
          this.journeyLoading = false;
        });
    },

    updateQuestions() {
      let today = new Date();
      let responseData = [];
      new Promise((resolve, reject) => {
        let counter = 0;
        this.surveyData.forEach((question) => {
          if (
            (question.rating && !question.answered) ||
            (question.feedback && !question.answered)
          ) {
            let newQuestion = {};
            newQuestion.compId = question.compId;
            newQuestion.id = question.id;
            newQuestion.journeyId = question.journeyId;
            newQuestion.order = question.order;
            newQuestion.stageId = question.stageId;
            newQuestion.question = question.question;
            newQuestion.type = question.type;
            newQuestion.answered = true;
            newQuestion.dateUpdated = today;
            newQuestion.rating = Number(question.rating);
            newQuestion.manualCompanyAnswered = true;

            if (question.feedback) {
              newQuestion.feedback = question.feedback;
            }
            responseData.push(newQuestion);
            counter++;
            if (counter === this.surveyData.length) {
              resolve();
            }
          } else {
            question.rating = Number(question.rating);
            question.manualCompanyAnswered = true;
            responseData.push(question);
            counter++;
            if (counter === this.surveyData.length) {
              resolve();
            }
          }
        });
      }).then(() => {
        db.collection("surveys")
          .doc(this.survey.id)
          .update({
            surveyQuestions: responseData,
            ratingSummary: this.ratingSumData,
            answered: true,
            manualCompanyAnswered: true,
          })
          .then(() => {
            if (this.type == "clients") {
              bus.$emit("surveyEditDialogChange", this.survey);
            } else if (this.type == "dossier") {
              bus.$emit("surveyEditDialogDossierChange", this.survey);
            }
            this.closeEditSurveyDialog();
          });
      });
    },

    add(a, b) {
      return a + b;
    },
  },
  computed: {
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    changed() {
      if (_.isEqual(this.surveyData, this.surveyDataOriginal) == false) {
        return true;
      } else {
        return false;
      }
    },
    averageScore() {
      if (this.ratingSumData.length > 0) {
        let givenRatings = this.ratingSumData.reduce(this.add, 0);
        let avarageScore;
        avarageScore = ((givenRatings * 2) / this.ratingSumData.length).toFixed(
          1,
        );
        return avarageScore;
      } else {
        return 0;
      }
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
};
</script>
